<script lang="ts">
    
    import type { Deliverable } from "../scripts/deliverable";
    import { storeLanguage, lang_fr } from "../scripts/store";

    export let props: Deliverable;

</script>

<style lang="scss">
	.tileDeliverable {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        margin: 60px 0 0 0;
        width: 100%;
        &__icon {
            height: 70px;
            padding: 0 0 30px 0;
        }
        &__title {
            padding: 0 0 30px 0;
        }
        &__text {
            padding: 0 16px 0 16px;
            text-align: center;
            padding: 0 0 30px 0;
            &__link {
                text-decoration: none;
                color: $color_primary;
            }

        }
	}

    @include large {
        .tileDeliverable {
            margin: 0px 15px 0 15px;
            padding: 30px 30px 30px 30px;
            transition: all 1s;
            border-radius: 20px 20px 20px 20px;
            width: 30%;
            &:hover {
                color: $color_primary;
                background-color: $color_grey;
                box-shadow: 8px 8px 8px $color_text;
            }
            &__title {
                text-align: center;
                white-space: nowrap;
            }
        }
    }

</style>

<div class="tileDeliverable">
    <img class="tileDeliverable__icon" alt="icon" src="../assets/images/deliverable.png">
    <div class="tileDeliverable__title font__h3">
        {#if ($storeLanguage == $lang_fr)}
        {props.title_fr}
        {:else}
        {props.title_en}
        {/if}
    </div>
    <div class="tileDeliverable__text">
        {#if ($storeLanguage == $lang_fr)}
        <a class="tileDeliverable__text__link" href="../assets/deliverables/worksites/{props.id}_{props.file_deliverable}" alt="Télécharger" target="_blank">{props.subtitle_fr}&nbsp;&darr</a>
        {:else}
        <a class="tileDeliverable__text__link" href="../assets/deliverables/worksites/{props.id}_{props.file_deliverable}" alt="Download" target="_blank">{props.subtitle_en}&nbsp;&darr</a>
        {/if}
    </div>
</div>
